// @ts-strict-ignore
import { AnalyticsDashboard } from "@dashboard/welcomePage/analytics/AnalyticsDashboard";
import React from "react";

const AnalyticsSection: React.FC = () => {
  return <AnalyticsDashboard />;
};

export default AnalyticsSection;
